import React from 'react';

const KebijakanPrivasiPage = () => (
  <div className="min-h-screen bg-white px-4 py-8 max-w-3xl mx-auto text-gray-800">
    <h1 className="text-2xl font-bold text-indigo-950 mb-6">Kebijakan Privasi — SIGAP GURU</h1>
    <p className="text-sm text-gray-500 mb-8">Terakhir diperbarui: Oktober 2026</p>

    <Section title="1. Pendahuluan">
      Aplikasi SIGAP GURU dikembangkan oleh Dinas Pendidikan Kabupaten Asmat sebagai sistem informasi kehadiran dan penilaian
      untuk pegawai di lingkungan Pemerintah Kabupaten Asmat. Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan,
      menggunakan, dan melindungi informasi pengguna.
    </Section>

    <Section title="2. Data yang Dikumpulkan">
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Data Identitas:</strong> Nama lengkap, NIP/NUPTK, alamat email, peran/jabatan</li>
        <li><strong>Data Lokasi:</strong> Koordinat GPS saat absensi, akurasi, altitude</li>
        <li><strong>Data Biometrik:</strong> Foto wajah untuk verifikasi, deskriptor wajah, hasil liveness detection</li>
        <li><strong>Data Foto:</strong> Foto absensi dengan watermark, foto kegiatan</li>
        <li><strong>Data Perangkat:</strong> Tipe perangkat, status koneksi, informasi GPS</li>
      </ul>
    </Section>

    <Section title="3. Penggunaan Data">
      Data digunakan untuk verifikasi kehadiran, pengenalan wajah, geo-fencing, pelaporan kehadiran,
      dan deteksi serta pencegahan kecurangan (fake GPS, foto palsu).
    </Section>

    <Section title="4. Penyimpanan Data">
      Data disimpan di server cloud terenkripsi (MongoDB Atlas). Foto disimpan di Cloudflare R2 Storage.
      Data offline disimpan sementara di perangkat dan disinkronkan saat online.
      Komunikasi dienkripsi menggunakan HTTPS dengan SSL Pinning.
    </Section>

    <Section title="5. Pembagian Data">
      Kami <strong>tidak membagikan</strong> data pengguna kepada pihak ketiga. Data hanya diakses oleh pengguna bersangkutan,
      Admin Dinas Pendidikan, Kepala Sekolah, dan Pimpinan Instansi sesuai hierarki.
    </Section>

    <Section title="6. Keamanan Data">
      Kami menerapkan enkripsi saat transit (HTTPS + SSL Pinning), autentikasi JWT, rate limiting,
      deteksi GPS palsu, dan verifikasi liveness untuk keamanan.
    </Section>

    <Section title="7. Hak Pengguna">
      Pengguna berhak mengakses data kehadiran pribadi, memperbarui informasi profil melalui admin,
      menghapus data wajah yang terdaftar, dan mengetahui data yang dikumpulkan.
    </Section>

    <Section title="8. Penyimpanan dan Penghapusan">
      Data kehadiran disimpan selama diperlukan untuk pelaporan. Data wajah dapat dihapus atas permintaan.
      Data pegawai yang tidak lagi aktif dapat dinonaktifkan oleh admin.
    </Section>

    <Section title="9. Perubahan Kebijakan">
      Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan akan diumumkan
      melalui aplikasi atau saluran komunikasi resmi.
    </Section>

    <Section title="10. Kontak">
      <p>Dinas Pendidikan Kabupaten Asmat</p>
      <p>Email: disdik@asmat.go.id</p>
      <p>Website: https://sigapasmat.app</p>
      <p>Alamat: Agats, Kabupaten Asmat, Papua Selatan, Indonesia</p>
    </Section>
  </div>
);

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg font-semibold text-indigo-900 mb-2">{title}</h2>
    <div className="text-sm leading-relaxed text-gray-700">{children}</div>
  </div>
);

export default KebijakanPrivasiPage;
